import { get, post } from '@/services/Axios';
import qs from 'qs';
import debounce from 'lodash.debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      accountOptions: [],
      accounts: [],
      account: {},
      loadAccountOptions: false,
      loadAccounts: true,
      loadAccount: false,
      loadFormAccount: false,
      loadExportAccount: false,
      paginationAccounts: {},
      formAccountOptionsName: '',
      searchAccountsOptions: ''
    };
  },
  watch: {
    searchAccountsOptions(val) {
      if (
        this[this.formAccountOptionsName] &&
        (!this[this.formAccountOptionsName].account ||
          val !== this[this.formAccountOptionsName].account.accountName)
      ) {
        this.getAccountOptions({ keyword: val });
      }
    }
  },
  methods: {
    getAccountOptions: debounce(async function(...param) {
      this.loadAccountOptions = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        sort: 'account_name',
        dir: 'ASC',
        filter: [
          {
            type: 'string',
            field: 'account_name',
            value: parameter.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/user/list', { params });
        this.accountOptions = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAccountOptions = false;
      }
    }, 500),
    async getAccounts(...param) {
      this.loadAccounts = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'account_name',
        dir: parameter.dir || 'ASC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/user/list', { params });
        this.accounts = results;
        this.paginationAccounts = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAccounts = false;
      }
    },
    async getAccount(id) {
      this.loadAccount = true;
      const params = {
        account_id: id
      };
      try {
        const { data } = await get('/user/detail', { params });
        this.account = data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAccount = false;
      }
    },
    async createAccount(request) {
      this.loadFormAccount = true;
      const requestBody = {
        account_name: request.account_name,
        account_code: request.account_code,
        account_mobilephone: request.account_mobilephone,
        account_email: request.account_email,
        account_position: request.account_position,
        account_unit_id: request.unit.unitId,
        account_group_id: request.group.accountGroupId,
        account_avatar: request.account_avatar,
        is_active: request.is_active ? 1 : 0,
        account_unit_name: request.rt
          ? `${request.rw}/${request.rt}`
          : `${request.rw}`
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/user/create', {
          data: payload
        });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAccount = false;
      }
    },
    async updateAccount(request, id) {
      this.loadFormAccount = true;
      const requestBody = {
        account_id: id,
        account_name: request.account_name,
        account_code: request.account_code,
        account_mobilephone: request.account_mobilephone,
        account_email: request.account_email,
        account_position: request.account_position,
        account_unit_id: request.unit.unitId,
        account_group_id: request.group.accountGroupId,
        account_avatar: request.account_avatar,
        is_active: request.is_active ? 1 : 0,
        account_unit_name: request.rt
          ? `${request.rw}/${request.rt}`
          : `${request.rw}`
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/user/update', {
          data: payload
        });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAccount = false;
      }
    },
    async deleteAccount(id) {
      this.loadFormAccount = true;
      const requestBody = { account_id: id };
      const payload = qs.stringify(requestBody);
      try {
        await post('/user/delete', {
          data: payload
        });
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAccount = false;
      }
    },
    async resetAccount(id) {
      this.loadFormAccount = true;
      const requestBody = { account_id: id };
      const payload = qs.stringify(requestBody);
      try {
        await post('/user/reset-password', {
          data: payload
        });
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAccount = false;
      }
    },
    async exportAccount() {
      this.loadExportAccount = true;
      try {
        const {
          data: { url }
        } = await get('/user/export');
        window.open(`${url}?download=1`);
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadExportAccount = false;
      }
    }
  }
};
